
import { Component, PropSync, Vue } from 'vue-property-decorator'

@Component({
  filters: {
    twoDigits (value: any) {
      if (value.toString().length <= 1) {
        return '0' + value.toString()
      }
      return value.toString()
    }
  },
  components: {
  }
})
export default class FlipClock extends Vue {
  @PropSync('startedAt', { type: Number }) started!: number;

  private created () {
    this.startTimer()
  }

  private timeData = [{
    current: 0,
    label: this.$t('timetrack.time.days'),
    elementId: 'flip-card-days-' + Date.now().toString(36) + Math.random().toString(36).substring(2)
  },
  {
    current: 0,
    label: this.$t('timetrack.time.hours'),
    elementId: 'flip-card-hours-' + Date.now().toString(36) + Math.random().toString(36).substring(2)
  },
  {
    current: 0,
    label: this.$t('timetrack.time.minutes'),
    elementId: 'flip-card-minutes-' + Date.now().toString(36) + Math.random().toString(36).substring(2)
  },
  {
    current: 0,
    label: this.$t('timetrack.time.seconds'),
    elementId: 'flip-card-seconds-' + Date.now().toString(36) + Math.random().toString(36).substring(2)
  }]

  private startTimer () {
    if (this.started) {
      setInterval(() => {
        this.updateDiffs()
      }, 1000)
    }
  }

  private updateDiffs () {
    const intervals = {
      second: 1000,
      minute: 1000 * 60,
      hour: 1000 * 60 * 60,
      day: 1000 * 60 * 60 * 24
    }
    if (this.started) {
      let diff = Math.abs(Date.now() - this.started)
      const days = Math.floor(diff / intervals.day)
      diff -= days * intervals.day
      const hours = Math.floor(diff / intervals.hour)
      diff -= hours * intervals.hour
      const minutes = Math.floor(diff / intervals.minute)
      diff -= minutes * intervals.minute
      const seconds = Math.floor(diff / intervals.second)
      this.timeData[0].current = days
      this.timeData[1].current = hours
      this.timeData[2].current = minutes
      this.timeData[3].current = seconds
    }
  }
}
